import * as XLSX from 'xlsx';
import reportsServices from '../../services/reports/reportservice';


export const gstSalesReportsExport = async (
    userId?: number,
    fromDate? : Date,
    toDate? : Date,
    invoiceNo? : number
) => {
    try {
        const requestBody = {
            userId,
            fromDate,
            toDate,
            invoiceNo
        };
        let response;
        if (requestBody) {
            response = await reportsServices.gstGSTSalesReportsListExport(requestBody);
        } 
        if (response.length === 0) {
            console.warn('No data received from the API.');
            return;
        }
        generateExcelGSTSalesReportLists(response);
    } catch (error) {
        console.error(`Error fetching or exporting GST Sales Report Data:`, error);
    }
};

const formatDate = (dateString: string | null | undefined): string => {
    if (!dateString || dateString.startsWith("0001")) return "";
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? "" : date.toLocaleDateString('en-GB');
}; 

const generateExcelGSTSalesReportLists = (orderList: any) => {
    if (!orderList || orderList.length === 0) {
        console.warn("No order data available for export.");
        return;
    }
    const orderData = gstSalesReportList(orderList);
    if (!orderData || orderData.length === 0) {
        console.warn("Processed data is empty.");
        return;
    }
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(orderData);
    XLSX.utils.sheet_add_aoa(ws, [
        ["Invoice#", "Invoice Date", "User Name",
         "Mobile#", "Address","Area Name", "SubDistrict Name", "District", "State",
         "Country","Pincode",  "GST #","GST Number",
         "HSN Code", "Product Name", "Invoiced Quantity",
         "Invoice Amount", "Invoice Tax Amount", "Invoiced Total Amount",]
    ], { origin: "A1" });
   XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'GSTSalesReportListExport.xlsx');
 
};
 
const gstSalesReportList = (gstSalesList:any[]) => {
    return gstSalesList.map(gstSales => ({
        "Invoice#": gstSales.invoiceNo,
        "Invoice Date": formatDate(gstSales.invoiceDate),
        "User Name": gstSales.userName,
        "Mobile#": gstSales.mobileNumber,
        "Address": gstSales.address1 + ' ' + gstSales.address2,
        "Area Name": gstSales.areaName,
        "SubDistrict Name": gstSales.subDistrictName || "",
        "District": gstSales.district || "",
        "State": gstSales.state || "",
        "Country": gstSales.country || "",
        "Pincode": gstSales.pinCode || "",
        "GST #": gstSales.gst || "",
        "GST Number": gstSales.gstNumber || "",
        "HSN Code": gstSales.hsnCode || "",
        "Product Name": gstSales.productName || "",
        "Invoiced Quantity": gstSales.invoicedQuantity || "",
        "Invoice Amount": gstSales.invoiceAmount || 0,
        "Invoice Tax Amount": gstSales.invoiceTaxAmount || 0,
        "Invoiced Total Amount": gstSales.invoiceTotalAmount || 0,
    }));
};